import React from 'react';

// styles
import { Colors, Spacing, Typography } from '_styles';

// bootstrap
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';

const TextLabel = (props) => {
    return (
        <div>
        <Form.Label style={{color:Colors.PRM_LIGHT_BLUE}}>{props.label}</Form.Label>
        <Form.Control 
            disabled={props.disabled} 
            type={props.type ? props.type : 'name'} 
            placeholder={props.placeholder} 
            style={{ }} 
            value={props.children} 
            defaultValue={props.children} 
        />
        </div>
    );
};

export default TextLabel;
